import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import '../pages/GeospatialPage.css';
import IndicatorMap from '../components/IndicatorMap';

const AVAILABLE_INDICATORS = ['unemployment', 'population', 'precipitation', 'temperature'];

export default function GeospatialPage({ onBack }) {
  const [summaryText, setSummaryText] = useState('');
  const [selectedYear, setSelectedYear] = useState(1991);
  const [selectedIndicator, setSelectedIndicator] = useState('unemployment');
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalRef = useRef(null);

  const summaryTextURL = process.env.PUBLIC_URL + '/content/individual_page_intros/GeospatialPage__intro.md';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(summaryTextURL)
      .then(res => res.text())
      .then(setSummaryText)
      .catch(console.error);
  }, [summaryTextURL]);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setSelectedYear(prev => (prev >= 2019 ? 1991 : prev + 1));
      }, 750);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying]);

  return (
    <>
      <Helmet>
        <title>Geospatial Analysis | Insight Data LLC</title>
      </Helmet>

      <div className='geo-home-container'>
        <div className='geo-image-credit'>
          Background image by Pixabay
        </div>
        <div className='geo-tile-box'>
          <div className='geo-back-button'>
            <button onClick={onBack} className="back-link">
               Back to Projects
            </button>
          </div>

          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#222' }}>
            Geospatial Labor Market Analysis
          </h1>

          <div className="geo-indicator-selector" style={{ marginTop: '1.5rem' }}>
            <label htmlFor="indicator">Select Indicator: </label>
            <select
              id="indicator"
              value={selectedIndicator}
              onChange={(e) => setSelectedIndicator(e.target.value)}
              style={{ marginLeft: '0.5rem' }}
            >
              {AVAILABLE_INDICATORS.map(ind => (
                <option key={ind} value={ind}>
                  {ind.charAt(0).toUpperCase() + ind.slice(1)}
                </option>
              ))}
            </select>
          </div>

          <div className="geo-year-slider" style={{ marginTop: '1.5rem' }}>
            <label htmlFor="yearRange">Select Year: {selectedYear}</label>
            <input
              id="yearRange"
              type="range"
              min="1991"
              max="2019"
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              style={{ width: '100%', marginTop: '0.5rem' }}
            />
            <button
              onClick={() => setIsPlaying(prev => !prev)}
              style={{ marginTop: '0.75rem', padding: '0.4rem 0.75rem' }}
            >
              {isPlaying ? 'Pause' : 'Play'}
            </button>
          </div>

          <div style={{
            marginTop: '1.5rem',
            marginBottom: '1.5rem',
            marginLeft: 'auto',
            marginRight: 'auto',
            position: 'relative',
            backgroundColor: 'white',
            zIndex: 9999
            }}>
            <IndicatorMap year={selectedYear} indicator={selectedIndicator} />
          </div>

          <div className="geo-project-description">
            <ReactMarkdown>
              {summaryText}
            </ReactMarkdown>
          </div>

          <div style={{ textAlign: 'right', marginTop: '1rem' }}>
            <a
              href="https://github.com/jakobjgu/python_folium"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#0039A6', fontSize: '0.875rem' }}
            >
              View GitHub Repo
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
